import useCommon from "@/shared/hooks/useCommon";
import useSendWaiterCord from "@/shared/queries/waiter/useSendWaiterCord";
import Button from "../Button/Button";

const ShareLocation = () => {
  const { check, isPending } = useSendWaiterCord();
  const t = useCommon();
  return (
    <Button isPending={isPending} onClick={() => check()}>
      {t("shareLocationAgain")}
    </Button>
  );
};

export default ShareLocation;
